module.exports = __webpack_public_path__ + "static/media/chibi_head.4b53fa37.png";